<template>
  <div class="bg-light">
    <nav-title :title="'Settings'" :color="false" />
    <article class="container d-flex flex-column">
      <section class="bg-white px-3 pt-3 pb-2 shadow-sm mt-2 mb-3">
        <p class="text-capitalize h5">{{ userName }} {{ userLastName }}</p>
        <b-link @click="showEditModal">
          Edit
        </b-link>
      </section>
      <section
        v-if="userIsAParent"
        class="d-flex py-2 pr-0 pl-2 justify-content-between border-bottom"
      >
        <p>Email notifications</p>
        <b-form-checkbox switch size="lg" v-model="emailNotification"></b-form-checkbox>
      </section>
      <section
        v-if="userIsAParent"
        class="d-flex py-2 pr-0 pl-2 justify-content-between border-bottom"
      >
        <div>
          <p>Daily notifications</p>
          <p v-if="!emailNotification" class="email_notification_warning">Available when email notification is active</p>
        </div>
        <div>
          <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-radio-group
              v-model="selectedHour"
              :options="options"
              :aria-describedby="ariaDescribedby"
              name="selected-hour"
              stacked
              :disabled="!emailNotification"
            ></b-form-radio-group>
          </b-form-group>
        </div>
      </section>
      <b-link
        v-if="userIsAParent"
        class="d-flex p-2 justify-content-between border-bottom"
        to="register-child"
      >
        <p class="text-dark">
          Add new child
        </p>
        <i class="material-icons align-middle text-main">
          add_circle
        </i>
      </b-link>
      <b-link
        v-if="userIsAParent"
        class="d-flex p-2 justify-content-between border-bottom"
        to="update-select-child?next=register-child"
      >
        <p class="text-dark">
          Edit child profile
        </p>
        <i class="material-icons align-middle text-main smaller">
          edit
        </i>
      </b-link>
      <section
        class="d-flex py-2 pr-0 pl-2 justify-content-between border-bottom align-items-center"
      >
        <p class="mr-5">Time zone</p>
        <b-form-select
          class="w-25 flex-grow-1 flex-sm-grow-0"
          size="sm"
          v-model="selectedZone"
          :options="getTimeZoneList"
        >
        </b-form-select>
      </section>
      <section class="py-2" v-if="userIsAParent">
        <b-button variant="primary" @click="$router.push({name: 'cliniciansReport'})">Clinician's report</b-button>
      </section>
      <section class="p-2">
        <b-link to="/about" class="text-dark">
          About
        </b-link>
      </section>
      <section class="p-2">
        <b-link to="/logout" class="text-dark">
          <i class="material-icons align-middle smaller mr-1">
            output
          </i>
          Log out
        </b-link>
      </section>
    </article>
    <b-modal
      v-model="modalEditName"
      hide-footer
      centered
      size="sm"
      no-close-on-backdrop
      no-close-on-esc
    >
      <template v-slot:modal-title>
        Profile
      </template>
      <div class="d-block">
        <b-form v-on:submit.prevent="updateName()" class="inputs-container">
          <div class="input-upper">
            <b-form-input type="text" class="mb-2" v-model="userName" required></b-form-input>
            <label class="small-icon">
              Name
            </label>
          </div>
          <div class="input-upper mt-4">
            <b-form-input type="text" class="mb-2" v-model="userLastName" required></b-form-input>
            <label class="small-icon">
              Last name
            </label>
          </div>
          <div class="input-date mt-0">
            <label class="small-icon label-date">
              Date of birth
            </label>
            <b-form-datepicker
              required
              class="mb-3"
              v-model="userBirthDate"
              placeholder="Date of birth"
              onfocus="(this.type='date')"
              onblur="(this.type='text')"
              :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"
            ></b-form-datepicker>
          </div>

          <b-button type="submit" variant="warning" block>
            Update
          </b-button>
        </b-form>
      </div>
    </b-modal>
    <clinician-report-modal ref="scm" @onShareReport="handleSaveReport" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import store from '@/store';
import mixinNotificationToast from '@/mixins/notificationToast.mixin.js';

import navTitle from '@/components/general/navTitle.vue';
import ClinicianReportModal from '@/components/general/modal/ClinicianReportModal';

export default {
  components: {
    navTitle,
    ClinicianReportModal,
  },
  mixins: [mixinNotificationToast],
  data() {
    return {
      modalEditName: false,
      emailNotification: false,
      selectedTime: 1,
      selectedFrequencyGoalsRecording: false,
      selectedZone: this.getTimeZone,
      sending: false,
      userName: this.getUserName,
      userLastName: this.getUserLastName,
      userBirthDate: this.getUserBirthDate,
      selectedHour: 6,
      options: [
        { text: '6 am', value: 6 },
        { text: '3 pm', value: 15 },
      ],
    };
  },
  computed: {
    ...mapGetters('user', [
      'userIsAParent',
      'getUserId',
      'getNotificationSetup',
      'getUserName',
      'getUserLastName',
      'getUserBirthDate',
      'getTimeZoneList',
      'getTimeZone',
    ]),
    ...mapGetters('parent', ['getDailyGoal']),
  },
  methods: {
    ...mapActions('user', ['parentConfigureNotifications', 'setupName', 'setTimeZone']),
    ...mapActions('parent', ['shareReport']),
    showEditModal() {
      this.modalEditName = true;
      this.userName = this.getUserName;
      this.userLastName = this.getUserLastName;
      this.userBirthDate = this.getUserBirthDate;
    },
    handleEmailNotification() {
      const userId = store.getters['user/getUserId'];
      const data = {
        id: userId,
        email: this.emailNotification,
        report: true,
        time: this.selectedHour,
      };
      store.dispatch('user/parentConfigureNotifications', data);
    },
    handleHourNotification(time) {
      const userId = store.getters['user/getUserId'];
      const data = {
        id: userId,
        email: this.emailNotification,
        report: true,
        time,
      };
      store.dispatch('user/parentConfigureNotifications', data);
    },
    updateName() {
      this.setupName({
        userIsAparent: this.userIsAParent,
        userId: this.getUserId,
        name: this.userName,
        last_name: this.userLastName,
        birth_date: this.userBirthDate,
      }).then(() => {
        this.modalEditName = false;
      });
    },
    updateSelects() {
      if (this.userIsAParent) {
        this.emailNotification = this.getNotificationSetup.has_email_notifications;
        this.selectedFrequencyGoalsRecording = this.getNotificationSetup.daily_family_report;
        this.selectedTime = this.getDailyGoal ? 1 : 2;
        this.selectedHour = this.getNotificationSetup.daily_family_report_time;
      }
    },
    async handleSaveReport(data) {
      try {
        await this.shareReport({ data, parentId: this.getUserId });
        this.notificationToast({
          message: 'The Report has been sent',
          variant: 'success',
          title: 'Settings',
        });
        this.$refs.scm.closeModal();
      } catch (error) {
        this.notificationToast({ message: error, variant: 'danger', title: "Clinician's report" });
      }
    },
  },
  watch: {
    emailNotification() {
      this.handleEmailNotification();
    },
    selectedHour(newHour) {
      this.handleHourNotification(newHour);
    },
    selectedZone(newValue) {
      if (newValue != this.getTimeZone) {
        let zone = parseFloat(newValue).toFixed(2);
        this.setTimeZone({
          userIsAparent: this.userIsAParent,
          userId: this.getUserId,
          time_zone: zone,
        });
      }
    },
    getTimeZone(newValue) {
      this.selectedZone = newValue;
    },
  },
  async created() {
    const userId = store.getters['user/getUserId'];
    await store.dispatch('user/parentGetNotificationsStup', userId);
    this.updateSelects();

    this.userName = this.getUserName;
    this.userLastName = this.getUserLastName;
    this.userBirthDate = this.getUserBirthDate;
    this.selectedZone = this.getTimeZone;
  },
  beforeMounted() {
    this.updateSelects();
  },
  beforeRouteEnter(to, from, next) {
    let userId = store.getters['user/getUserId'];
    let userIsAParent = store.getters['user/userIsAParent'];
    let data = { userIsAparent: userIsAParent, userId: userId };
    Promise.all([
      store.dispatch('user/fetchTimeZone'),
      store.dispatch('user/GetTimeZone', data),
    ]).then(() => {
      next();
    });

    if (store.getters['user/userIsAParent']) {
      Promise.all([
        store.dispatch('user/parentGetNotificationsStup', userId),
        store.dispatch('parent/GetGoalSetup', userId),
        store.dispatch('user/getUserData', data),
      ]).then(() => {
        next();
      });
    } else {
      next();
    }
  },
};
</script>
<style scoped>
.inputs-container .input-upper label {
  left: 5px !important;
}

.email_notification_warning {
  font-size: 0.8rem;
  color: #ffc107;
  margin-top: 5px;
}
</style>
